import { colorDeTexto } from '@xiltrion/ui/paleta';

/** Color de una app en la paleta (1–12): el que eligió la consola o uno estable sacado de su código. */
export const appColor = (app: { code: string; color: number | null }) => app.color ?? colorDeTexto(app.code);
